import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Row, Col } from 'antd/lib';
import { LocalizationContext } from '../../hoc/Localization';
import TitleContent from '../TinyComponents/TitleContent';
import SchoolLink from '../TinyComponents/SchoolLink';
import styles from '../SchoolInfo/styles.less';
import MarkDown from '../TinyComponents/MarkDown';

const Gallery = dynamic(() => import('../Gallery'));

const Content = ({ school }) => (
  <div>
    <SchoolLink school={school} />
    <MarkDown source={school.description} />
  </div>
);

Content.propTypes = {
  school: PropTypes.object.isRequired,
};

const SchoolInfo = ({ school, schoolGalleryHidden, mapShow }) => {
  const { t } = React.useContext(LocalizationContext);
  return (
    <Row id="schoolInfo" type="flex" className={styles.row}>
      {school && school.description && (
        <Col className={`${styles.about} ${styles.col}`} xs={24} md={12}>
          <TitleContent title={t('details.about')} content={<Content school={school} />} />
        </Col>
      )}

      {school && school.images && !schoolGalleryHidden && mapShow && (
        <Col className={`${styles.gallery} ${styles.col}`} xs={24} md={12}>
          {school.images && school.images.length >= 1 && (
            <TitleContent
              title={t('details.gallery')}
              content={<Gallery images={school.images} />}
            />
          )}
        </Col>
      )}
    </Row>
  );
};

SchoolInfo.propTypes = {
  school: PropTypes.object.isRequired,
  schoolGalleryHidden: PropTypes.bool,
  mapShow: PropTypes.bool,
};

SchoolInfo.defaultProps = {
  schoolGalleryHidden: false,
  mapShow: false,
};

export default SchoolInfo;
